import ModalForm from "../UI/ModalForm";
import ModalFormInputRow from "../UI/ModalFormInputRow";
import Modal from "../UI/Modal";
import React, {useRef} from "react";

const UserThematicModal = (props) => {
    const thematics = props.thematics;
    const handleCancel = props.handleCancel;
    const handleSubmit = props.handleSubmit;

    const selectRef = useRef(null);

    const handleFormSubmit = (event) => {
        event.preventDefault();

        const thematicId = parseInt(selectRef.current.value);

        handleSubmit(thematicId);
    }

    return <Modal>
        <form onSubmit={handleFormSubmit}>
            <ModalForm
                title="Add thematic"
                saveButtonTitle="Add"
                handleCancelButtonClick={handleCancel}
            >
                <ModalFormInputRow title="Thematic">
                    <select ref={selectRef} className="border rounded-lg py-2 px-3 w-full text-gray-700 focus:outline-none focus:shadow-outline">
                        {
                            thematics.map(
                                (option) => (
                                    <option key={option.thematicId} value={option.thematicId}>{option.name}</option>
                                )
                            )
                        }
                    </select>
                </ModalFormInputRow>
            </ModalForm>
        </form>
    </Modal>
}

export default UserThematicModal;
